import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { productAPI, favoritesAPI, chatAPI } from '../services/api';
import notificationService from '../services/notificationService';
import BrandLoader from '../components/BrandLoader';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Badge,
  InputBase,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Chip,
  Avatar,
  Divider,
  Paper,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Slider,
  FormGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
      InputAdornment,
    Alert,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
         Tabs,
  Tab,
  Snackbar,
  Tooltip,
  Switch
} from '@mui/material';
import {
  Search as SearchIcon,
  Notifications as NotificationsIcon,
  ShoppingCart as CartIcon,
  Chat as ChatIcon,
  LocationOn as LocationIcon,
  Star as StarIcon,
  AccessTime as TimeIcon,
  Add as AddIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  LocalOffer as OfferIcon,
  Home as HomeIcon,
  Person as PersonIcon,
  FilterList as FilterListIcon,
  KeyboardArrowDown as ArrowDownIcon,
  MyLocation,
  CheckCircle,
  Favorite,
  FavoriteBorder,
  StarBorder,
  Close,
     Remove as RemoveIcon
} from '@mui/icons-material';
import { styled, alpha } from '@mui/material/styles';
import BottomNavigation from '../components/BottomNavigation';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContextNew';
import SignUpPromptModal from '../components/SignUpPromptModal';
import Cart from '../components/Cart';
import useResponsive from '../hooks/useResponsive';
import { formatCurrency, getCountryCode } from '../utils/countryUtils';


// Styled components (same as Home screen)
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const Store = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user, isGuest, isAuthenticated } = useAuth();
  const { 
    isMobile: isResponsiveMobile, 
    isTablet, 
    isDesktop,
    getResponsiveValue,
    getResponsiveSpacing,
    getDialogProps 
  } = useResponsive();
  
  // State management
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [mobileSearchDialogOpen, setMobileSearchDialogOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [chatCount, setChatCount] = useState(0);
  const [favorites, setFavorites] = useState(new Set());
  const [favoriteLoading, setFavoriteLoading] = useState(new Set());
  
       // Cart context
  const { totalItems, addToCart, isInCart, getItemQuantity, removeFromCart, updateQuantity, items, refreshCart } = useCart();
  

  

  

  
  // Filter states
  const [priceRange, setPriceRange] = useState([0, 200]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [sortBy, setSortBy] = useState('featured');
  const [inStockOnly, setInStockOnly] = useState(false);
     const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Guest mode states
  const [showSignUpPrompt, setShowSignUpPrompt] = useState(false);
  const [restrictedFeature, setRestrictedFeature] = useState('');
  
     // Notification states
   const [showSuccessNotification, setShowSuccessNotification] = useState(false);
   const [successMessage, setSuccessMessage] = useState('');
   
   // Cart dialog state
   const [cartDialogOpen, setCartDialogOpen] = useState(false);

  // Fetch notification count
  const fetchNotificationCount = async () => {
    try {
      const notifications = await notificationService.fetchNotifications();
      const unreadCount = notifications.filter(n => !n.isRead).length;
      setNotificationCount(unreadCount);
    } catch (error) {
      console.error('Error fetching notification count:', error);
      setNotificationCount(0);
    }
  };

  // Fetch chat unread count
  const fetchChatCount = async () => {
    try {
      const response = await chatAPI.getUnreadCount();
      if (response.success) {
        setChatCount(response.data.unreadCount);
      } else {
        console.error('Error fetching chat count:', response.error);
        setChatCount(0);
      }
    } catch (error) {
      console.error('Error fetching chat count:', error);
      setChatCount(0);
    }
  };

  // Categories
  const categories = [
    'All',
    'Hair Care',
    'Skincare',
    'Makeup',
    'Nails',
    'Tools',
    'Wellness',
    'Fragrances',
    'Bath & Body'
  ];

  // State for products data
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // Check favorite status for products
  const checkProductFavorites = async (productIds) => {
    try {
      const favoritePromises = productIds.map(async (productId) => {
        try {
          const response = await favoritesAPI.checkFavoriteStatus(productId, 'product');
          return { productId, isFavorite: response.success && response.data.isFavorite };
        } catch (error) {
          return { productId, isFavorite: false };
        }
      });
      
      const results = await Promise.all(favoritePromises);
      const newFavorites = new Set();
      results.forEach(({ productId, isFavorite }) => {
        if (isFavorite) {
          newFavorites.add(productId);
        }
      });
      setFavorites(newFavorites);
    } catch (error) {
      // Error checking product favorites
    }
  };

  // Fetch products from API
  const fetchProducts = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch products specifically for customers with customer pricing - filtered by country
      // Use customer products endpoint which supports country filtering
      const baseUrl = process.env.REACT_APP_API_URL || 'https://api.nistylez.com/api';
      const apiUrl = `${baseUrl}/customer/products`;
      
      // Get auth token for authenticated users
      const customerToken = localStorage.getItem('customerToken');
      const token = localStorage.getItem('token');
      const authToken = customerToken || token;
      
      // Get country code for header (already handled by api interceptor, but adding here for direct fetch)
      const countryCode = getCountryCode();
      
      const response = await fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
          'X-Country-Code': countryCode
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.success && data.data && data.data.products) {
          // Transform the backend data to match our frontend structure
          const transformedProducts = data.data.products
            .filter(product => product._id || product.id) // Only include products with valid IDs
            .map((product) => {
            const transformed = {
              id: product._id || product.id,
              name: product.name,
              brand: product.brand || 'NISTYLEZ',
              // Use customer-specific pricing fields from backend
              price: product.customerSalePrice || product.customerPrice || product.price || 0,
              originalPrice: product.customerPrice || product.originalPrice || product.price || 0,
              customerPrice: product.customerPrice,
              customerSalePrice: product.customerSalePrice,
              customerDiscountPercentage: product.customerDiscountPercentage,
              description: product.description,
              image: product.primaryImage || (product.images && product.images.length > 0 ? product.images[0] : 'https://images.unsplash.com/photo-1522338140263-f46f5913618a?w=300&h=200&fit=crop'),
              category: product.category || 'General',
              inStock: (product.stock || 0) > 0,
              rating: product.rating || 4.5,
              reviews: product.reviewCount || product.totalReviews || 0,
              featured: product.isFeatured || false,
              stock: product.stock || 0,
              discountPercentage: product.customerDiscountPercentage || product.discountPercentage || 0
            };
            
            return transformed;
          });
          
          setProducts(transformedProducts);
          
          // Check favorite status for all products
          const productIds = transformedProducts.map(product => product.id);
          await checkProductFavorites(productIds);
        } else {
          setProducts([]);
        }
      } else {
        setProducts([]);
      }
    } catch (error) {
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

     // Fetch products when component mounts
   useEffect(() => {
     fetchProducts();
   }, []);

   // Fetch notification and chat counts when component mounts
   useEffect(() => {
     if (isAuthenticated && !isGuest) {
       fetchNotificationCount();
       fetchChatCount();
     }
   }, [isAuthenticated, isGuest]);

   // Listen for window focus to refresh counts
   useEffect(() => {
     const handleFocus = () => {
       if (isAuthenticated && !isGuest) {
         fetchNotificationCount();
         fetchChatCount();
       }
     };

     window.addEventListener('focus', handleFocus);
     return () => window.removeEventListener('focus', handleFocus);
   }, [isAuthenticated, isGuest]);

   
 
      // Filter and sort products using useMemo to prevent unnecessary recalculations
   const filteredProducts = React.useMemo(() => {
     
     const filtered = products.filter(product => {
       const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            (product.brand && product.brand.toLowerCase().includes(searchQuery.toLowerCase())) ||
                            (product.description && product.description.toLowerCase().includes(searchQuery.toLowerCase()));
       
       const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
       
       const matchesPrice = product.price >= priceRange[0] && product.price <= priceRange[1];
       
       const matchesStock = !inStockOnly || product.inStock;
       
       return matchesSearch && matchesCategory && matchesPrice && matchesStock;
     }).sort((a, b) => {
       switch (sortBy) {
         case 'price-low':
           return a.price - b.price;
         case 'price-high':
           return b.price - a.price;
         case 'rating':
           return b.rating - a.rating;
         case 'reviews':
           return b.reviews - a.reviews;
         case 'featured':
           // Sort by featured first, then by rating
           if (a.featured && !b.featured) return -1;
           if (!a.featured && b.featured) return 1;
           return b.rating - a.rating;
         default:
           // Default sort: featured first, then by rating
           if (a.featured && !b.featured) return -1;
           if (!a.featured && b.featured) return 1;
           return b.rating - a.rating;
       }
     });
     
     
     return filtered;
   }, [products, searchQuery, selectedCategory, priceRange, inStockOnly, sortBy]);

  // Guest mode handlers
  const handleGuestRestriction = (featureName) => {
    setRestrictedFeature(featureName);
    setShowSignUpPrompt(true);
  };

  const handleProductClick = (product) => {
    // Ensure we have a valid product ID before navigating
    if (product && product.id && product.id !== 'featured' && product.id !== 'undefined' && product.id !== 'null') {
      try {
        navigate(`/product/${product.id}`);
      } catch (error) {
        setError('Navigation failed. Please try again.');
      }
    } else {
      // Show an error message or handle gracefully
      setError('Unable to view product details. Please try again.');
    }
  };

                                                                                                                                                                                                                                                                                                                                                                                                 const handleAddToCart = async (product) => {
    try {
      // Ensure we have a valid product ID
      const productId = product.id || product._id;
      if (!productId) {
        setError('Invalid product data');
        return;
      }
      
      // Add to cart context - await the async operation
      const result = await addToCart({
        id: productId,
        name: product.name,
        price: product.price,
        image: product.image,
        itemType: 'product',
        providerId: 'store',
        quantity: 1
      });
      
      setSuccessMessage(`${product.name} added to cart!`);
      setShowSuccessNotification(true);
      setTimeout(() => {
        setShowSuccessNotification(false);
      }, 3000);
      
    } catch (error) {
      setError('Failed to add item to cart. Please try again.');
    }
  };

      const handleRemoveFromCart = (product) => {
        const productId = product.id || product._id;
        const currentQuantity = getItemQuantity(productId);
        
        // Find the cart item to get its cartItemId
        const cartItem = items.find(item => 
          item.id === productId || item._id === productId
        );
        
        if (!cartItem) {
          return;
        }
        
        if (currentQuantity > 1) {
          // Decrease quantity by 1
          updateQuantity(cartItem.cartItemId, currentQuantity - 1);
        } else {
          // Remove the item completely
          removeFromCart(cartItem.cartItemId);
        }
      };

       const handleInStockOnlyChange = (event) => {
      setInStockOnly(event.target.checked);
    };






  const toggleFavorite = async (productId) => {
    // Prevent multiple clicks while processing
    if (favoriteLoading.has(productId)) return;
    
    setFavoriteLoading(prev => new Set(prev).add(productId));
    
    try {
      const isCurrentlyFavorite = favorites.has(productId);
      
      if (isCurrentlyFavorite) {
        // Remove from favorites
        // First, we need to get the favoriteId from the backend
        const response = await favoritesAPI.checkFavoriteStatus(productId, 'product');
        if (response.success && response.data.favoriteId) {
          await favoritesAPI.removeFromFavorites(response.data.favoriteId);
          setFavorites(prev => {
            const newFavorites = new Set(prev);
            newFavorites.delete(productId);
            return newFavorites;
          });
        }
      } else {
        // Add to favorites
        await favoritesAPI.addToFavorites(productId, 'product');
        setFavorites(prev => new Set(prev).add(productId));
      }
    } catch (error) {
      // Error toggling favorite
    } finally {
      setFavoriteLoading(prev => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <StarIcon
        key={index}
        sx={{
          color: index < Math.floor(rating) ? '#ffd700' : '#e0e0e0',
          fontSize: 12
        }}
      />
    ));
  };

  // Helper function to strip HTML tags from description
  const stripHtmlTags = (htmlString) => {
    if (!htmlString) return '';
    // Create a temporary div element to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    // Return only the text content
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  // Auto-scroll photo gallery effect
  useEffect(() => {
    if (filteredProducts.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === filteredProducts.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [filteredProducts.length]);

  return (
    <Box sx={{ flexGrow: 1, backgroundColor: '#f5f5f5', pb: 8, width: '100%', minHeight: '100vh' }}>
             {/* Loading State */}
       {loading && (
         <Box sx={{ 
           display: 'flex', 
           justifyContent: 'center', 
           alignItems: 'center', 
           minHeight: '200px',
           flexDirection: 'column',
           gap: 2
         }}>
           <BrandLoader />
         </Box>
       )}
       
       {/* Content - Show when not loading */}
       {!loading && (
        <>
          {/* Header - Same as Home screen */}
      <AppBar position="static" sx={{ backgroundColor: '#1a237e', color: '#ffffff' }}>
        <Toolbar sx={{ 
          minHeight: { xs: '56px', sm: '64px' },
          px: { xs: 1, sm: 2, md: 3 }
        }}>
          {/* Logo */}
          <Box sx={{ 
            flexGrow: 0, 
            mr: { xs: 1, sm: 2, md: 3 },
            display: 'flex',
            alignItems: 'center'
          }}>
            <img 
              src="/logo.png" 
              alt="NISTYLEZ Logo"
              style={{ 
                width: isMobile ? '100px' : '140px', 
                height: isMobile ? '35px' : '50px',
                borderRadius: '8px',
                objectFit: 'contain'
              }}
            />
          </Box>

          {/* Search Bar */}
          <Box sx={{ 
            display: isMobile ? 'none' : 'flex', 
            alignItems: 'center', 
            flexGrow: 1, 
            mr: { xs: 1, sm: 2 }, 
            ml: { xs: 1, sm: 2 },
            minWidth: 0
          }}>

            <Search sx={{ 
              flexGrow: 1, 
              mr: 1, 
              maxWidth: { xs: 200, sm: 300, md: 400 }
            }}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search products..."
                inputProps={{ 'aria-label': 'search' }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                  }
                }}
              />
              <IconButton
                onClick={() => setFilterDialogOpen(true)}
                sx={{ 
                  position: 'absolute',
                  right: 8,
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: 'white' },
                  fontSize: { xs: '18px', sm: '24px' }
                }}
              >
                <FilterListIcon />
              </IconButton>
            </Search>
          </Box>

          {/* Mobile Search Button - Show only on mobile */}
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <IconButton
              color="inherit"
              onClick={() => {
                setMobileSearchDialogOpen(true);
              }}
              sx={{ 
                p: 0.5,
                minWidth: '40px',
                minHeight: '40px',
                mr: 1
              }}
            >
              <SearchIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Box>

          {/* Right side icons */}
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>

            <IconButton 
              color="inherit" 
              sx={{ 
                mr: { xs: 0, sm: 1 },
                p: { xs: 0.5, sm: 1 },
                minWidth: { xs: '40px', sm: 'auto' },
                minHeight: { xs: '40px', sm: 'auto' }
              }}
              onClick={() => {
                if (isGuest) {
                  handleGuestRestriction('chat');
                } else {
                  navigate('/chat');
                }
              }}
            >
              <Badge badgeContent={chatCount} color="error">
                <ChatIcon sx={{ fontSize: { xs: '20px', sm: '24px' } }} />
              </Badge>
            </IconButton>
            <IconButton 
              color="inherit" 
              sx={{ 
                mr: { xs: 0, sm: 1 },
                p: { xs: 0.5, sm: 1 },
                minWidth: { xs: '40px', sm: 'auto' },
                minHeight: { xs: '40px', sm: 'auto' }
              }}
              onClick={() => {
                if (isGuest) {
                  handleGuestRestriction('notifications');
                } else {
                  // Reset notification count when user opens notifications page
                  setNotificationCount(0);
                  navigate('/notifications');
                }
              }}
            >
              <Badge 
                badgeContent={notificationCount > 0 ? notificationCount : null} 
                color="error"
              >
                <NotificationsIcon sx={{ fontSize: { xs: '20px', sm: '24px' } }} />
              </Badge>
            </IconButton>
            <Tooltip title={`NISTYLEZ Store (${totalItems} items)`} arrow>
              <IconButton 
                color="inherit" 
                sx={{ 
                  p: { xs: 0.5, sm: 1 },
                  minWidth: { xs: '40px', sm: 'auto' },
                  minHeight: { xs: '40px', sm: 'auto' }
                }}
                onClick={() => {
                  setCartDialogOpen(true);
                }}
              >
                <Badge badgeContent={totalItems} color="error">
                  <CartIcon sx={{ fontSize: { xs: '20px', sm: '24px' } }} />
                </Badge>
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

             {/* Main Content */}
       <Box sx={{ 
          flexGrow: 1,
          p: { xs: 1, sm: 2, md: 3 },
          width: '100%',
          maxWidth: '100%',
          backgroundColor: '#f5f5f5',
          mt: { xs: 1, sm: 2 },
          pb: { xs: 10, sm: 3 }, // Add bottom padding for mobile to account for bottom navigation
          boxSizing: 'border-box'
        }}>
         

         

         

         {/* Category Tabs */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ 
            display: 'flex', 
            gap: 1, 
            overflowX: 'auto', 
            pb: 1,
            '&::-webkit-scrollbar': { height: 4 },
            '&::-webkit-scrollbar-track': { bgcolor: '#f1f1f1', borderRadius: 2 },
            '&::-webkit-scrollbar-thumb': { bgcolor: '#c1c1c1', borderRadius: 2 },
            '&::-webkit-scrollbar-thumb:hover': { bgcolor: '#a8a8a8' }
          }}>
            {categories.map((category) => (
              <Chip
                key={category}
                label={category}
                onClick={() => setSelectedCategory(category)}
                sx={{
                  bgcolor: selectedCategory === category ? '#1a237e' : 'white',
                  color: selectedCategory === category ? 'white' : '#1a237e',
                  border: selectedCategory === category ? 'none' : '1px solid #1a237e',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: selectedCategory === category ? '#1a237e' : '#f0f0f0'
                  }
                }}
              />
            ))}
          </Box>
        </Box>

        {/* Sort and Filter Bar */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 3,
          flexWrap: 'wrap',
          gap: 2
        }}>
                     <Typography variant="body2" color="text.secondary">
             {filteredProducts.length} products found {inStockOnly ? '(In Stock Only)' : ''}
           </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Sort by</InputLabel>
              <Select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                label="Sort by"
              >
                <MenuItem value="featured">Featured</MenuItem>
                <MenuItem value="price-low">Price: Low to High</MenuItem>
                <MenuItem value="price-high">Price: High to Low</MenuItem>
                <MenuItem value="rating">Highest Rated</MenuItem>
                <MenuItem value="reviews">Most Reviews</MenuItem>
              </Select>
            </FormControl>
                                                                                                                                                                                                                                                                                                                                                                                                                               <Box 
                              sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1,
                                cursor: 'pointer',
                                userSelect: 'none',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                backgroundColor: inStockOnly ? '#e3f2fd' : 'transparent',
                                border: inStockOnly ? '1px solid #1976d2' : '1px solid #ddd',
                                '&:hover': {
                                  backgroundColor: inStockOnly ? '#bbdefb' : '#f5f5f5'
                                }
                              }}
                              onClick={() => {
                                setInStockOnly(!inStockOnly);
                              }}
                            >
                              <Box
                                sx={{
                                  width: 20,
                                  height: 20,
                                  borderRadius: '50%',
                                  backgroundColor: inStockOnly ? '#1976d2' : '#ccc',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '12px',
                                  color: 'white',
                                  fontWeight: 'bold'
                                }}
                              >
                                {inStockOnly ? '✓' : ''}
                              </Box>
                              <Typography 
                                variant="body2" 
                                sx={{ 
                                  fontSize: '0.8rem',
                                  color: inStockOnly ? '#1976d2' : '#666',
                                  fontWeight: inStockOnly ? 'bold' : 'normal'
                                }}
                              >
                                In Stock Only
                              </Typography>
                            </Box>
          </Box>
        </Box>

                 {/* Products Grid */}
         <Grid container spacing={1.5}>
           {filteredProducts.map((product) => (
                              <Grid item xs={6} sm={4} md={3} lg={2} xl={2} key={`${product.id}-${getItemQuantity(product.id)}`}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  cursor: 'pointer',
                  borderRadius: 3,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                  }
                }}
                onClick={(e) => {
                  handleProductClick(product);
                }}
              >
                <Box sx={{ position: 'relative' }}>
                                    <CardMedia
                    component="img"
                    height={{ xs: 160, sm: 180, md: 200 }}
                    image={product.image}
                    alt={product.name}
                    sx={{ 
                      objectFit: 'cover',
                      width: '100%',
                      height: { xs: 160, sm: 180, md: 200 },
                      maxHeight: { xs: 160, sm: 180, md: 200 },
                      minHeight: { xs: 160, sm: 180, md: 200 }
                    }}
                  />
                  
                  {/* Favorite Button */}
                                    <IconButton
                    sx={{
                      position: 'absolute',
                      top: 6,
                      right: 6,
                      bgcolor: 'rgba(255,255,255,0.9)',
                      '&:hover': { bgcolor: 'white' },
                      width: 28,
                      height: 28
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(product.id);
                    }}
                    disabled={favoriteLoading.has(product.id)}
                  >
                    {favoriteLoading.has(product.id) ? (
                      <BrandLoader size="small" showText={false} />
                    ) : favorites.has(product.id) ? (
                      <Favorite sx={{ color: '#e91e63', fontSize: 16 }} />
                    ) : (
                      <FavoriteBorder sx={{ color: '#666', fontSize: 16 }} />
                    )}
                  </IconButton>

                  

                                    {/* Featured Badge */}
                  {product.featured && (
                    <Chip
                      label="Featured"
                      sx={{
                        position: 'absolute',
                        top: 6,
                        left: 6,
                        backgroundColor: '#ffd700',
                        color: '#333',
                        fontWeight: 'bold',
                        fontSize: '0.5rem',
                        height: 18,
                        '& .MuiChip-label': {
                          fontSize: '0.5rem',
                          px: 0.5
                        }
                      }}
                    />
                  )}

                                      {/* Out of Stock Badge - Position based on whether featured badge is present */}
                   {!product.inStock && (
                     <Chip
                       label="Out of Stock"
                       sx={{
                         position: 'absolute',
                         top: 6,
                         right: product.featured ? 40 : 6, // Move right if featured badge is present
                         backgroundColor: '#f44336',
                         color: 'white',
                         fontWeight: 'bold',
                         fontSize: '0.5rem',
                         height: 18,
                         '& .MuiChip-label': {
                           fontSize: '0.5rem',
                           px: 0.5
                         }
                       }}
                     />
                   )}
               </Box>

                                                  <CardContent sx={{ 
                                                    flexGrow: 1, 
                                                    p: { xs: 1, sm: 1.5 },
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'space-between'
                                                  }}>
                   <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0.5, fontSize: '0.8rem' }}>
                     {product.name}
                   </Typography>
                   
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontSize: '0.7rem' }}>
                    by {product.brand}
                  </Typography>

                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                   <Box sx={{ display: 'flex', alignItems: 'center' }}>
                     {Array.from({ length: 5 }, (_, index) => (
                       <StarIcon
                         key={index}
                         sx={{
                           color: '#ffd700',
                           fontSize: 12
                         }}
                       />
                     ))}
                   </Box>
                   {/* Discount Chip - Moved from image to rating line */}
                   {product.customerPrice && product.customerSalePrice && product.customerPrice > product.customerSalePrice && (
                     <Chip
                       label={`${product.customerDiscountPercentage || Math.round(((product.customerPrice - product.customerSalePrice) / product.customerPrice) * 100)}% OFF`}
                       size="small"
                       sx={{
                         backgroundColor: '#ff6b35',
                         color: 'white',
                         fontWeight: 'bold',
                         fontSize: '0.55rem',
                         height: 16,
                         '& .MuiChip-label': {
                           fontSize: '0.55rem',
                           px: 0.5,
                           py: 0
                         }
                       }}
                     />
                   )}
                 </Box>

                                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                     <Box>
                       <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2', fontSize: '0.9rem' }}>
                         {formatCurrency(product.customerSalePrice || product.customerPrice)}
                       </Typography>
                       {product.customerPrice && product.customerSalePrice && product.customerPrice > product.customerSalePrice && (
                         <Typography variant="body2" sx={{ textDecoration: 'line-through', color: '#999', fontSize: '0.6rem' }}>
                           {formatCurrency(product.customerPrice)}
                         </Typography>
                       )}
                     </Box>
                   </Box>

                                                                                                  {/* Cart Controls */}
                   {(() => {
                     const productId = product.id || product._id;
                     const quantity = getItemQuantity(productId);
                     const inCart = isInCart(productId);
                     
                     if (inCart) {
                       return (
                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                           <IconButton
                             size="small"
                             onClick={(e) => {
                               e.stopPropagation();
                               handleRemoveFromCart(product);
                             }}
                             sx={{
                               bgcolor: '#f5f5f5',
                               border: '1px solid #ddd',
                               width: 24,
                               height: 24,
                               '&:hover': { bgcolor: '#e0e0e0' }
                             }}
                           >
                             <RemoveIcon sx={{ fontSize: 16 }} />
                           </IconButton>
                           <Typography variant="body2" sx={{ minWidth: 20, textAlign: 'center', fontSize: '0.8rem' }}>
                             {quantity}
                           </Typography>
                           <IconButton
                             size="small"
                             onClick={(e) => {
                               e.stopPropagation();
                               handleAddToCart(product);
                             }}
                             sx={{
                               bgcolor: '#1a237e',
                               color: 'white',
                               width: 24,
                               height: 24,
                               '&:hover': { bgcolor: '#0d47a1' }
                             }}
                           >
                             <AddIcon sx={{ fontSize: 16 }} />
                           </IconButton>
                         </Box>
                       );
                     } else {
                       return (
                         <Button
                           variant="contained"
                           fullWidth
                           size="small"
                           disabled={false}
                           onClick={(e) => {
                             e.stopPropagation();
                             e.preventDefault();
                             handleAddToCart(product);
                           }}
                           onMouseDown={(e) => {
                             e.stopPropagation();
                             e.preventDefault();
                           }}
                           sx={{
                             fontSize: { xs: '0.65rem', sm: '0.7rem' },
                             minHeight: '32px',
                             maxHeight: '32px',
                             py: 0.5,
                             bgcolor: '#1a237e',
                             '&:hover': { bgcolor: '#0d47a1' },
                             pointerEvents: 'auto',
                             position: 'relative',
                             zIndex: 10,
                             whiteSpace: 'nowrap',
                             textTransform: 'none'
                           }}
                         >
                           Add to Cart
                         </Button>
                       );
                     }
                   })()}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* No Results */}
        {filteredProducts.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <SearchIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
              No products found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Try adjusting your search or filter criteria
            </Typography>
          </Box>
        )}
      </Box>

      {/* Filter Dialog */}
      <Dialog 
        open={filterDialogOpen} 
        onClose={() => setFilterDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Filters</Typography>
            <IconButton onClick={() => setFilterDialogOpen(false)}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Price Range</Typography>
            <Slider
              value={priceRange}
              onChange={(e, newValue) => setPriceRange(newValue)}
              valueLabelDisplay="auto"
              min={0}
              max={200}
              sx={{ mb: 2 }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2">{formatCurrency(priceRange[0])}</Typography>
              <Typography variant="body2">{formatCurrency(priceRange[1])}</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Brands</Typography>
            <FormGroup>
              {Array.from(new Set(products.map(p => p.brand))).map((brand) => (
                <FormControlLabel
                  key={brand}
                  control={
                    <Checkbox
                      checked={selectedBrands.includes(brand)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedBrands([...selectedBrands, brand]);
                        } else {
                          setSelectedBrands(selectedBrands.filter(b => b !== brand));
                        }
                      }}
                    />
                  }
                  label={brand}
                />
              ))}
            </FormGroup>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Rating</Typography>
            <FormGroup>
              {[5, 4, 3, 2, 1].map((rating) => (
                <FormControlLabel
                  key={rating}
                  control={
                    <Checkbox
                      checked={selectedRatings.includes(rating)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedRatings([...selectedRatings, rating]);
                        } else {
                          setSelectedRatings(selectedRatings.filter(r => r !== rating));
                        }
                      }}
                    />
                  }
                                     label={
                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
                       {Array.from({ length: 5 }, (_, i) => (
                         <StarIcon
                           key={i}
                           sx={{
                             color: i < rating ? '#ffd700' : '#e0e0e0',
                             fontSize: 16
                           }}
                         />
                       ))}
                       <Typography variant="body2" sx={{ ml: 1 }}>
                         {rating}
                       </Typography>
                     </Box>
                   }
                />
              ))}
            </FormGroup>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setPriceRange([0, 200]);
            setSelectedBrands([]);
            setSelectedRatings([]);
            setInStockOnly(false);
          }}>
            Clear All
          </Button>
          <Button onClick={() => setFilterDialogOpen(false)} variant="contained">
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Mobile Search Dialog */}
      <Dialog
        open={mobileSearchDialogOpen}
        onClose={() => setMobileSearchDialogOpen(false)}
        fullScreen={isMobile}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            margin: isMobile ? 0 : '16px',
            maxHeight: isMobile ? '100vh' : '90vh',
            borderRadius: isMobile ? 0 : '8px'
          }
        }}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          pb: 1
        }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Search Products
          </Typography>
          <IconButton
            onClick={() => setMobileSearchDialogOpen(false)}
            sx={{ p: 0.5 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        
        <DialogContent sx={{ p: 2 }}>
          {/* Search Input */}
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setSearchQuery('')}
                      edge="end"
                    >
                      <Close />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '16px' // Prevents zoom on iOS
                }
              }}
            />
          </Box>

          {/* Category Selection */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
              Select Category
            </Typography>
            <Box sx={{ 
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1
            }}>
              {categories.map((category) => (
                <Chip
                  key={category}
                  label={category}
                  onClick={() => setSelectedCategory(category)}
                  variant={selectedCategory === category ? 'filled' : 'outlined'}
                  sx={{
                    backgroundColor: selectedCategory === category ? '#1976d2' : 'transparent',
                    color: selectedCategory === category ? 'white' : '#1976d2',
                    borderColor: '#1976d2',
                    '&:hover': {
                      backgroundColor: selectedCategory === category ? '#1565c0' : '#e3f2fd'
                    }
                  }}
                />
              ))}
            </Box>
          </Box>

          {/* Rating Filter */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
              Minimum Rating
            </Typography>
            <FormGroup>
              {[1, 2, 3, 4, 5].map((rating) => (
                <FormControlLabel
                  key={rating}
                  control={
                    <Checkbox
                      checked={selectedRatings.includes(rating)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedRatings([...selectedRatings, rating]);
                        } else {
                          setSelectedRatings(selectedRatings.filter(r => r !== rating));
                        }
                      }}
                    />
                  }
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {Array.from({ length: 5 }, (_, index) => (
                        <StarIcon
                          key={index}
                          sx={{
                            color: index < rating ? '#ffd700' : '#e0e0e0',
                            fontSize: 16
                          }}
                        />
                      ))}
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {rating} star{rating > 1 ? 's' : ''} & up
                      </Typography>
                    </Box>
                  }
                />
              ))}
            </FormGroup>
          </Box>

          {/* In Stock Only Toggle */}
          <Box sx={{ mb: 3 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={inStockOnly}
                  onChange={(e) => setInStockOnly(e.target.checked)}
                  color="primary"
                />
              }
              label="In Stock Only"
            />
          </Box>

          {/* Sort Options */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
              Sort By
            </Typography>
            <FormControl fullWidth>
              <Select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                displayEmpty
              >
                <MenuItem value="featured">Featured</MenuItem>
                <MenuItem value="price-low">Price: Low to High</MenuItem>
                <MenuItem value="price-high">Price: High to Low</MenuItem>
                <MenuItem value="rating">Rating</MenuItem>
                <MenuItem value="newest">Newest</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => {
              setSearchQuery('');
              setSelectedCategory('All');
              setSelectedRatings([]);
              setInStockOnly(false);
              setSortBy('featured');
            }}
            variant="outlined"
            fullWidth={isMobile}
          >
            Clear All
          </Button>
          <Button
            onClick={() => setMobileSearchDialogOpen(false)}
            variant="contained"
            fullWidth={isMobile}
            sx={{ bgcolor: '#1976d2' }}
          >
            Apply Search
          </Button>
        </DialogActions>
      </Dialog>

             {/* Bottom Navigation */}
       <BottomNavigation />

      {/* Success Notification */}
      <Snackbar
        open={showSuccessNotification}
        autoHideDuration={3000}
        onClose={() => setShowSuccessNotification(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setShowSuccessNotification(false)} 
          severity="success" 
          sx={{ width: '100%' }}
        >
          {successMessage}
        </Alert>
      </Snackbar>

                 {/* Sign Up Prompt Modal for Guest Users */}
         <SignUpPromptModal
           open={showSignUpPrompt}
           onClose={() => setShowSignUpPrompt(false)}
           featureName={restrictedFeature}
         />
         
         {/* Cart Dialog */}
         <Cart
           open={cartDialogOpen}
           onClose={() => setCartDialogOpen(false)}
         />
         </>
       )}
     </Box>
   );
 };

export default Store; 